<template>
  <div v-loading="loading">
    <a-page-header
      title="国际园数据填报"
      style="padding-left: 0; margin-bottom: 10px; border-bottom: 1px solid rgb(235, 237, 240)"
    />
    <div class="search-form">
      <a-form :labelCol="{span: 6}" :wrapperCol="{span: 18}">
        <a-row>
          <a-col :span="3">
            <a-form-item label="标题">
              <a-input v-model.trim="searchForm.title" allow-clear placeholder="请输入大屏标题" class="width-100" />
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item label="状态">
              <a-select v-model="searchForm.status" placeholder="请选择状态" style="width: 100%">
                <a-select-option v-for="(label, code, idx) in statusCodeEnum" :key="code" :value="code">{{label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="">
              <a-button class="gap-left-10" icon="search" type="primary" @click="pageChange({current: 1, pageSize: 10})">搜索</a-button>
              <a-button class="gap-left-10" icon="redo" @click="resetSearchForm">重置</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="">
      <a-button 
        icon="plus"
        type="primary"
        @click="goEditPage" 
        v-if="$checkButtonPermissions($buttonPermissionsConfig.dataSubForm.internationManage.edit)"
      >新增</a-button>
    </div>
    <div class="gap-top-10">
      <a-table 
        :rowKey="(record, index) => record.dashboardFillId" 
        :columns="table.columns" 
        :data-source="table.dataInfo"
        :pagination="table.pagination.total ? table.pagination : false" 
        bordered 
        @change="pageChange">
        <div slot="status" slot-scope="text, record" >
          <a-switch v-model="record.status" @change="(state)=>changeRowStatus(state, record)" />
        </div>
        <div slot="action" slot-scope="text, record" class="action">
          <a-button 
            class="btnClass" 
            @click="goCatPage(record)"
            type="link"
          >查看</a-button>
          <!-- v-if="showEditButton(record)" -->
          <a-button 
            class="btnClass" 
            type="link" 
            @click="goEditPage(record)" 
            v-if="$checkButtonPermissions($buttonPermissionsConfig.dataSubForm.internationManage.edit)"
          >编辑</a-button>
          <!-- v-if="showDeleteButton(record)" -->
          <a-button 
            class="btnClass" 
            type="link" 
            style="color: #F05656;" 
            @click="remove(record)"
            v-if="$checkButtonPermissions($buttonPermissionsConfig.dataSubForm.internationManage.delete)"
          >删除</a-button>
        </div>
      </a-table>
    </div>
  </div>
</template>
<script>
import * as api from "@/api/dataAnalysis/dataSubForm.js";
export default {
  components: {

  },
  data() {
      return {
        loading: false,
        searchForm: {
          title: '',
          status: null,
        },
        table: {
          dataInfo: [],
          pagination: {
            showSizeChanger: true,
            current: 1,
            pageSize: 10,
            total: 0,
            showQuickJumper: true,
            showTotal: (total) => {
              return `共 ${total} 条`;
            },
          },
          columns: [
            {
              title: '标题',
              dataIndex: 'title',
              key: 'title',
              customRender: (text) => text || '-',
            },
            {
              title: '状态',
              dataIndex: 'status',
              key: 'status',
              width: '120px',
              scopedSlots: {
                customRender: 'status'
              }
            },
            {
              title: '创建人',
              dataIndex: 'createName',
              key: 'createName',
              width: '170px',
              customRender: (text) => (text || '-'),
            },
            {
              title: '修改时间',
              dataIndex: 'createTime',
              key: 'createTime',
              width: '170px',
              customRender: (text) => (text || '-').replace("T", " ")
            },
            {
              title: '最后更新人',
              dataIndex: 'updateName',
              key: 'updateName',
              width: '170px',
              customRender: (text) => text || '-',
            },
            {
              title: '最后更新时间',
              dataIndex: 'updateTime',
              key: 'updateTime',
              width: '170px',
              customRender: (text) => (text || '-').replace("T", " "),
            },
            {
              title: '操作',
              key: 'action',
              width: '180px',
              fixed: 'right',
              scopedSlots: { customRender: 'action' },
            },
          ]
        },
        statusCodeEnum:{
          0: '禁用',
          1: '启用',
        }
      }
  },
  computed: {

  },
  created(){

  },
  mounted(){
      this.getList();
  },
  methods: {
    goCatPage(row){
      this.$router.push({path: "/dataSubForm/internation/cat", query: {id: row.dashboardFillId}});
    },
    remove({dashboardFillId}){
      this.loading = true;
      return api.deleteData({dashboardFillId})
      .finally(()=>{
        this.loading = false;
      })
      .then(({code, data, msg})=>{
        if(code == 200){
          this.$message.success(msg);
          this.getList();
        }else{
          this.$message.error(msg);
        }
      });
    },
    goEditPage(row){
      this.$router.push({path: "/dataSubForm/internation/edit", query: row ? {id: row.dashboardFillId} : {}});
    },
    changeRowStatus(newState, {dashboardFillId}){
      console.log("新状态", newState);
      this.loading = true;
      return api.changeStatus({dashboardFillId, status: newState ? 1 : 0})
      .finally(()=>{
        this.loading = false;
      })
      .then(({code, data, msg})=>{
        if(code == 200){
          this.$message.success(msg);
        }else{
          this.$message.error(msg);
        }
        this.getList();
      });
    },
    resetSearchForm(){
      this.searchForm = {
        title: '',
        status: null,
      };
      this.table.pagination.current = 1;
      this.table.pagination.pageSize = 10;
      this.getList();
    },
    pageChange(option){
      this.table.pagination.current = option.current;
      this.table.pagination.pageSize = option.pageSize;
      this.getList();
    },
    getList(){
      this.loading = true;
      const params = {
        pageNum: this.table.pagination.current,
        pageSize: this.table.pagination.pageSize,
      }
      const searhTitle = this.searchForm.title;
      if(searhTitle){
        params.title = searhTitle;
      }
      const searchStatus = this.searchForm.status;
      if(searchStatus !== null){
        params.status = Number(searchStatus);
      }
      console.log('searchFormParam', params);
      this.loading = true;
      return api.getManageList(params)
      .finally(()=>{
        this.loading = false;
      })
      .then(({code, data, msg})=>{
        if(code == 200){
          this.table.dataInfo = (data.list || []).map(it => {
            it["status"] = it["status"] === 1;
            return it;
          });
          this.table.pagination.total = data.total;
        }else{
          this.$message.error(msg || "请求失败");
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .btnClass{
    padding: 0px 4px !important;
    line-height: normal;
  }
  ::v-deep .search-form .ant-form-item{
    margin-bottom: 10px !important;
  }
  .gap-left-10{
    margin-left: 10px;
  }
  .gap-top-10{
    margin-top: 10px;
  }
</style>